export default __webpack_public_path__ + "static/media/unnamed.46e1cd75.png";